export type Lang = 'de' | 'en';

export interface Strings {
  langName: string;
  switchTo: string;
  nav: { privacy: string; imprint: string; allTools: string };
  hero: { title: string; subtitle: string; localBadge: string };
  ui: {
    dropTitle: string;
    dropHint: string;
    downloadZip: string;
    snippet: string;
    manifest: string;
    copy: string;
    copied: string;
    error: string;
  };
  seo: {
    aboutTitle: string;
    aboutBody: string;
    faqTitle: string;
    faq: { q: string; a: string }[];
  };
  footer: { rights: string; noStorage: string };
}

const de: Strings = {
  langName: 'Deutsch',
  switchTo: 'English',
  nav: { privacy: 'Datenschutz', imprint: 'Impressum', allTools: 'Alle Tools' },
  hero: {
    title: 'Favicon-Generator',
    subtitle:
      'Erzeuge aus einem Bild ein komplettes Favicon-Set (ICO, PNGs, Manifest) direkt im Browser. Dein Bild wird nicht hochgeladen.',
    localBadge: '100 % lokal · kostenlos',
  },
  ui: {
    dropTitle: 'Bild hierher ziehen',
    dropHint: 'oder klicken — PNG, JPG oder SVG, am besten quadratisch. Bleibt lokal.',
    downloadZip: 'Alles als ZIP herunterladen',
    snippet: 'HTML-Einbindung',
    manifest: 'site.webmanifest',
    copy: 'Kopieren',
    copied: 'Kopiert',
    error: 'Bild konnte nicht verarbeitet werden. Bitte ein anderes versuchen.',
  },
  seo: {
    aboutTitle: 'Favicons sicher und lokal erzeugen',
    aboutBody:
      'Dieser Generator erstellt aus einem Bild ein vollständiges Favicon-Set (favicon.ico, PNGs in allen gängigen Größen, apple-touch-icon, site.webmanifest und den HTML-Einbindungs-Snippet) ausschließlich lokal in deinem Browser. Dein Bild wird nicht hochgeladen oder gespeichert.',
    faqTitle: 'Häufige Fragen',
    faq: [
      {
        q: 'Wird mein Bild hochgeladen?',
        a: 'Nein. Die Skalierung läuft lokal über ein Canvas im Browser; es findet keine Übertragung statt.',
      },
      {
        q: 'Welche Dateien bekomme ich?',
        a: 'favicon.ico (16/32/48), favicon-16/32/48, apple-touch-icon (180), android-chrome 192 und 512, site.webmanifest und den HTML-Snippet — als ZIP oder einzeln.',
      },
      {
        q: 'Welches Eingabebild ist ideal?',
        a: 'Ein quadratisches PNG oder SVG mit mindestens 512x512 px liefert die schärfsten Ergebnisse.',
      },
    ],
  },
  footer: {
    rights: 'Kostenlose Tools von ecosquirrel.',
    noStorage: 'Keine serverseitige Speicherung. Alles läuft lokal im Browser.',
  },
};

const en: Strings = {
  langName: 'English',
  switchTo: 'Deutsch',
  nav: { privacy: 'Privacy', imprint: 'Imprint', allTools: 'All tools' },
  hero: {
    title: 'Favicon Generator',
    subtitle:
      'Turn one image into a full favicon set (ICO, PNGs, manifest) right in your browser. Your image is never uploaded.',
    localBadge: '100% local · free',
  },
  ui: {
    dropTitle: 'Drop an image here',
    dropHint: 'or click — PNG, JPG or SVG, ideally square. Stays local.',
    downloadZip: 'Download all as ZIP',
    snippet: 'HTML snippet',
    manifest: 'site.webmanifest',
    copy: 'Copy',
    copied: 'Copied',
    error: 'Could not process the image. Please try another one.',
  },
  seo: {
    aboutTitle: 'Generate favicons securely and locally',
    aboutBody:
      'This generator turns one image into a complete favicon set (favicon.ico, PNGs in all common sizes, apple-touch-icon, site.webmanifest and the HTML snippet) exclusively in your browser. Your image is not uploaded or stored.',
    faqTitle: 'Frequently asked questions',
    faq: [
      {
        q: 'Is my image uploaded?',
        a: 'No. Scaling runs locally on a canvas in the browser; nothing is transmitted.',
      },
      {
        q: 'Which files do I get?',
        a: 'favicon.ico (16/32/48), favicon-16/32/48, apple-touch-icon (180), android-chrome 192 and 512, site.webmanifest and the HTML snippet — as a ZIP or individually.',
      },
      {
        q: 'What input image is best?',
        a: 'A square PNG or SVG of at least 512x512 px gives the crispest results.',
      },
    ],
  },
  footer: {
    rights: 'Free tools by ecosquirrel.',
    noStorage: 'No server-side storage. Everything runs locally in your browser.',
  },
};

export const STRINGS: Record<Lang, Strings> = { de, en };
